export default "__VITE_ASSET__CEj7PaLh__"